import React, { forwardRef } from "react";
import classNames from "classnames";
import styled from "styled-components";
import IBuildrProps from '../../../utilities/IBuildrProps';
import { isLink } from '../utilities';

export interface IHashNavProps extends IBuildrProps {
    children;
    title?: string;
    description?: string;
}

export default styled(forwardRef((props: IHashNavProps, ref: any) => {
    const { children, cmsId, editorClassObj, className, title, description } = props;

    function handleClick(e, url, isUrlLink) {
        if (!isUrlLink) {
            e.preventDefault();
            document.getElementById(url)?.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }

    return (
        <div data-id={cmsId} className={classNames(className, 'w-lg-100 mx-3 p-4 px-5 pb-5 m-lg-0 p-lg-0 bg-redRock d-lg-flex', editorClassObj)}>
            {title ? <div className="text-center text-white d-lg-none mb-2 title">{title}</div> : null}
            {description ? <div className="text-center text-white d-lg-none mb-2 description">{description}</div> : null}
            <div className={classNames("text-center text-white d-lg-none jump-to mb-4 text-uppercase", title || description ? 'mt-5' : 'mt-3')}>Jump to</div>
            <ul className={classNames("w-lg-100 navbar-nav px-0 flex-column flex-grow-1 flex-lg-row align-items-center justify-content-around container")}>
                {
                    React.Children.map(children, (child) => {
                        const isUrlLink = isLink(child.props.url);
                        return React.cloneElement(child, {
                            ...child.props,
                            onClick: e => handleClick(e, child.props.url, isUrlLink),
                            temporaryIsHashLink: true, // temporary until all HashNav 'NavLink' usages are replaced with the newer 'HashLink' widget
                            url: isUrlLink ? child.props.url : `#${(child.props.url || '').toLowerCase()}`,
                        });
                    })
                }
            </ul>
        </div>
    );
}))`
min-height: 2.67rem;
font-family: 'National2';
.jump-to {
    font-size: 0.78rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1rem;
}
.title {
    font-size: 1.78rem;
    font-weight: 350;
    letter-spacing: -0.018rem;
    text-transform: capitalize;
}
.description {
    font-size: 0.89rem;
    font-weight: 400;
    line-height: 1.33rem;
}
`;